import { useReviewSelectionOrchestration } from '@/context/use-review-selection-orchestration';
import { Sort } from '@/types/sort.type';

type UseReviewsPageProviderSelectionConnectionArgs = {
    accessToken: string;
    selectionSessionId: string;
    filtersQuery: string[];
    sort: Sort;
    selectionReconcileRevision: number;
    setPickedReviews: (value: string[]) => void;
};

export const useReviewsPageProviderSelectionConnection = ({
    accessToken,
    selectionSessionId,
    filtersQuery,
    sort,
    selectionReconcileRevision,
    setPickedReviews,
}: UseReviewsPageProviderSelectionConnectionArgs) => {
    return useReviewSelectionOrchestration({
        accessToken,
        selectionSessionId,
        filtersQuery,
        sort,
        selectionReconcileRevision,
        setPickedReviews,
    });
};
